import { getFunctions, httpsCallable } from 'firebase/functions';
import { getApp } from 'firebase/app';
import axios from 'axios';
import { useAuthStore } from '@/v2/store/shared/auth-store';

export const getDeepValue = (obj, keys) => {
	if (typeof keys === 'string') {
		keys = keys.split('.');
	}

	const key = keys.shift();

	const keyData = obj[key];

	if (!keyData) {
		return keyData;
	}

	if (keys.length === 0) {
		return keyData;
	}

	return getDeepValue(keyData, keys);
};

export const generateFiltersArray = (data, filtersFields, joinChar = '|') => {
	const res = [];

	const values = [];
	filtersFields.forEach((field) => {
		const value = getDeepValue(data, field);
		if (value !== undefined) {
			values.push(`${field}-${value}`);
		}
	});

	values.sort((a, b) => (a > b ? 1 : a == b ? 0 : -1));

	const current = [];
	const generateCombinations = (idx = 0) => {
		if (idx === values.length) {
			res.push(current.join(joinChar));
			return;
		}

		generateCombinations(idx + 1);

		current.push(values[idx]);
		generateCombinations(idx + 1);
		current.pop();
	};

	generateCombinations();

	return res;
};

// Firebase Cloud Functions utility
export const callFirebaseFunction = async (functionName, data = {}, options = {}) => {
	const { method = 'post', headers = {} } = options;
	try {
		const authStore = useAuthStore();
		const idToken = await authStore.getIdToken();

		let result = null;
		if (method === 'get') {
			result = await axios.get(`${process.env.MIX_API_FUNCTION_BASE_URL}/${functionName}`, {
				...data,
				headers: {
					tenantId: authStore.tenantId,
					Authorization: `Bearer ${idToken}`,
					...headers,
				},
			});
		} else if (method === 'delete') {
			result = await axios.delete(`${process.env.MIX_API_FUNCTION_BASE_URL}/${functionName}`, {
				...data,
				headers: {
					tenantId: authStore.tenantId,
					Authorization: `Bearer ${idToken}`,
					...headers,
				},
			});
		} else {
			result = await axios[method](
				`${process.env.MIX_API_FUNCTION_BASE_URL}/${functionName}`,
				data,
				{
					headers: {
						tenantId: authStore.tenantId,
						Authorization: `Bearer ${idToken}`,
						...headers,
					},
				},
			);
		}

		return result.data;
	} catch (error) {
		console.error(`Error calling Firebase function ${functionName}:`, error);
		throw error;
	}
};
